import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
} from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  // ListEnvironmentalObjetivesForms, // comentado: ver nota en el tab "objetivos" más abajo
  EnvironmentalObjetivesForm,
  ObjectivesMatrix,
  GoalsAndActions,
  StrategicPlan,
  PlanDocument,
  Guide,
} from "../../../components/Admin/EnvironmentalObjetivesForms";
import { useAuth } from "../../../hooks";
import { Form, EnvironmentalObjetivesform } from "../../../api";
import { encrypt, decrypt } from "../../../utils/cryptoUtils";
import { useLocation } from "react-router-dom";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../utils/checkPermission";
import "./EvironmentalObjetivesForms.scss";
import { useLanguage, useSite } from "../../../contexts";

const formController = new Form();
const environmentalObjetivesFormController = new EnvironmentalObjetivesform();

export function EnvironmentalObjetivesForms() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const {
    accessToken,
    user: { role, site },
  } = useAuth();
  const [siteSelected, setSiteSelected] = useState(null);
  const [loading, setLoading] = useState(true);
   const [configFormData, setConfigFormData] = useState([]);
  const [activeTab, setActiveTab] = useState("objetivos");
  // En el HTML de referencia el contador vive en "Matriz 5 años", no en
  // "Definir objetivo" (donde estaba antes de sacar el listado).
  const [objectivesCount, setObjectivesCount] = useState(0);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const location = useLocation();

  const siteContext = useSite().site;

  useEffect(() => {
    (async () => {
      try {
        if (siteContext !== "") {
          setSiteSelected(siteContext);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [siteContext]);

  useEffect(() => {
    (async () => {
      try {
        if (site) {
          setSiteSelected(site);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [site]);

    useEffect(() => {
      (async () => {
        try {
            setLoading(true);
            if (siteSelected && siteSelected !== "" && siteSelected !=="undefined") {
              const response = await formController.getFormsBySite(
                accessToken,
                siteSelected,
                "environmentalObjetive"
              );
              if (response.length > 0) {
                setConfigFormData(response[0]);
              }else{
                setConfigFormData({module:"environmentalObjetive",site:siteSelected})
              }
              setLoading(false);
              setReload(false);
          }
        } catch (error) {
          console.error(error);
          setConfigFormData([]);
        }
      })();
    }, [siteSelected, accessToken, reload]);

  useEffect(() => {
    (async () => {
      try {
        if (location.state?.siteSelected) {
          setSiteSelected(decrypt(location.state.siteSelected));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [location]);

  useEffect(() => {
    (async () => {
      try {
        if (siteSelected && siteSelected !== "" && siteSelected !== "undefined") {
          const response = await environmentalObjetivesFormController.getEnvironmentalObjetivesFormsBySite(
            accessToken,
            siteSelected
          );
          const objs = response.code === 200 ? response.objetives || [] : [];
          setObjectivesCount(objs.filter((o) => o.active !== false).length);
        } else {
          setObjectivesCount(0);
        }
      } catch (error) {
        console.error(error);
        setObjectivesCount(0);
      }
    })();
  }, [siteSelected, accessToken, reload]);

  const showSiteWarning =
    siteSelected === null && (isMaster(role) || (isAdmin(role) && !site));

  return (
    <>
      <div className="environmentalObjetive-forms-page">
        <div className="env-obj-page-header-wrapper">
          <div className="env-obj-page-header">
            <h1 className="env-obj-page-title">Objetivos ambientales</h1>
          </div>
        </div>

        <div className="env-obj-tabs">
          <button
            type="button"
            className={`env-obj-tab${activeTab === "objetivos" ? " active" : ""}`}
            onClick={() => setActiveTab("objetivos")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
            Definir objetivo
          </button>
          <button
            type="button"
            className={`env-obj-tab${activeTab === "matriz" ? " active" : ""}`}
            onClick={() => setActiveTab("matriz")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
              <path d="M2 6h12M2 10h12M6 2v12" stroke="currentColor" strokeWidth="1.4" />
            </svg>
            Matriz 5 años
            <span className="env-obj-tab-count">{objectivesCount}</span>
          </button>
          <button
            type="button"
            className={`env-obj-tab${activeTab === "metas" ? " active" : ""}`}
            onClick={() => setActiveTab("metas")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M3 4.5h2M3 8h2M3 11.5h2M7 4.5h6M7 8h6M7 11.5h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            Metas y acciones
          </button>
          <button
            type="button"
            className={`env-obj-tab${activeTab === "estrategia" ? " active" : ""}`}
            onClick={() => setActiveTab("estrategia")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
              <circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.4" />
            </svg>
            Plan Estratégico
          </button>
          <button
            type="button"
            className={`env-obj-tab${activeTab === "documento" ? " active" : ""}`}
            onClick={() => setActiveTab("documento")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M4 2h5l3 3v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
              <path d="M9 2v3h3" stroke="currentColor" strokeWidth="1.4" />
            </svg>
            Plan (documento)
          </button>
          <button
            type="button"
            className={`env-obj-tab${activeTab === "guia" ? " active" : ""}`}
            onClick={() => setActiveTab("guia")}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M3 2.5h7a2 2 0 0 1 2 2V14l-2-1.4L8 14l-2-1.4L4 14V4.5" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
            </svg>
            Guía
          </button>
        </div>

        <div className="env-obj-tab-content">
          {showSiteWarning ? (
            <div className="no-site-warning">
              <Icon name="warning sign" size="big" />
              <p>{t("select_company_site_from_header")}</p>
            </div>
          ) : activeTab === "objetivos" ? (
            // Listado con tabs por aspecto comentado: el filtro por año exacto
            // no tiene sentido con "año meta" (siempre > año actual, nunca
            // matchea el año seleccionado por defecto) y quedaba vacío. Se
            // reemplaza por "Definir objetivo" solo, como en el HTML de
            // referencia — revisar/editar objetivos existentes se hace desde
            // el Plan Estratégico (Nivel 2) o la Matriz 5 años.
            // <ListEnvironmentalObjetivesForms
            //   reload={reload}
            //   onReload={onReload}
            //   siteSelected={siteSelected}
            //   yearSelected={yearSelected}
            //   setYearSelected={setYearSelected}
            //   configFormData={configFormData}
            //   setReload={setReload}
            //   onObjectiveCreated={() => setActiveTab("estrategia")}
            // />
            <EnvironmentalObjetivesForm
              onReload={onReload}
              siteSelected={siteSelected}
              configFormData={configFormData}
              sumImpact={0}
              onCreated={() => setActiveTab("estrategia")}
            />
          ) : activeTab === "matriz" ? (
            <ObjectivesMatrix siteSelected={siteSelected} />
          ) : activeTab === "metas" ? (
            <GoalsAndActions siteSelected={siteSelected} />
          ) : activeTab === "estrategia" ? (
            <StrategicPlan siteSelected={siteSelected} />
          ) : activeTab === "documento" ? (
            <PlanDocument siteSelected={siteSelected} />
          ) : (
            <Guide />
          )}
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("environmentalObjetive_form")}
        size={"fullscreen"}
      >
        <EnvironmentalObjetivesForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          siteSelected={siteSelected}
          configFormData={configFormData}
          onCreated={() => setActiveTab("estrategia")}
        />
      </BasicModal>
    </>
  );
}
